const getDeviceType = (deviceType?: string | null) => {
  if (deviceType === 'all') {
    return 'すべて';
  } else if (deviceType === 'pc') {
    return 'PCのみ';
  } else if (deviceType === 'mobile') {
    return 'スマートフォンのみ';
  } else return '';
};

export default getDeviceType;
